import type { ClassValue } from 'clsx';

import './rateComponentStyling.css';

interface Parameters {
  executable: boolean;
  cantTrade: boolean;
}

// returns classNames to apply depending on rate nature and user trade permission
export const getRateComponentStyling = ({ executable, cantTrade }: Parameters): ClassValue[] => [
  'realtime-rate',
  { cantTrade, executable },
];
